module.exports = __webpack_public_path__ + "img/663f85d.png";